import React from "react";

import { BrowserRouter, Route, Switch } from "react-router-dom";

import { layouts } from "configs/layout/Layouts";
import ProtectedRoute from "./ProtectedRoute";
import { Routes } from "./Routes";

const Router = () => {
  return (
    <BrowserRouter>
      <Switch>
        {Routes.map((route) => {
          const layout = route.layout || "main";

          const page = layouts[layout](route.component);

          return (
            <Route
              key={route.path}
              path={route.path}
              exact={route.exact}
              render={() => (
                <ProtectedRoute auth={route.auth} roles={route.roles}>
                  {page}
                </ProtectedRoute>
              )}
            />
          );
        })}
      </Switch>
    </BrowserRouter>
  );
};

export default Router;
